import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GiftCard } from '../../models/gift-card';
import { GiftCardService } from '../../services/gift-card.service';
import {
  SeoService,
  SEOTags,
  PageTitleService,
  PAGE_TITLES,
} from '@myclubrewards/shared';

@Component({
  selector: 'myclubrewards-gift-card',
  templateUrl: './gift-card.component.html',
  styleUrls: ['./gift-card.component.scss'],
})
export class GiftCardComponent implements OnInit {
  giftCard$: Observable<GiftCard>;

  constructor(
    private giftCardService: GiftCardService,
    private seoService: SeoService,
    private pageTitleService: PageTitleService
  ) {
    this.giftCard$ = this.giftCardService.giftCardSubj$;
    this.seoService.updateTags(SEOTags.GIFT_CARDS);
    this.pageTitleService.setTitle(PAGE_TITLES.GIFT_CARDS_PAGE_TITLE);
  }

  ngOnInit() {
    if (!this.giftCardService.hasValue()) {
      this.giftCardService.queryEarnRedeem();
    }
  }
}
